import { render, staticRenderFns } from "./demoUserMultiSelectTable.vue?vue&type=template&id=58fa1c39&scoped=true&"
import script from "./demoUserMultiSelectTable.vue?vue&type=script&lang=js&"
export * from "./demoUserMultiSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa1c39",
  null
  
)

export default component.exports